// src/components/widgets/WidgetProducts.jsx

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Currency from '../shared/Currency';
import WidgetImage from './WidgetImage';

function WidgetProducts({ title, products }) {
  return (
    <div className="widget-products widget">
      <h4 className="widget__title">{title}</h4>
      <div className="widget-products__list">
        {products.map((product) => {
          // Build the price display
          let priceDisplay;
          if (product.compareAtPrice !== undefined) {
            priceDisplay = (
              <>
                <span className="widget-products__new-price">
                  <Currency value={product.price} currency={product.currency} />
                </span>{' '}
                <span className="widget-products__old-price">
                  <Currency value={product.compareAtPrice} currency={product.currency} />
                </span>
              </>
            );
          } else {
            priceDisplay = (
              <Currency value={product.price} currency={product.currency} />
            );
          }

          return (
            <div key={product.id} className="widget-products__item">
              {/* Thumbnail */}
              <WidgetImage product={product} />

              {/* Name & Link */}
              <div className="widget-products__info">
                <div className="widget-products__name">
                  <Link to={`/shop/product/${product.id}`}>
                    {product.name}
                  </Link>
                </div>

                {/* Price */}
                <div className="widget-products__prices">
                  {priceDisplay}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

WidgetProducts.propTypes = {
  /**
   * Widget title
   */
  title: PropTypes.node,
  /**
   * Array of product objects from new API shape
   */
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      price: PropTypes.number,
      currency: PropTypes.string,
      compareAtPrice: PropTypes.number,
      // and any other fields you use (images, attributes, etc.)
    })
  ),
};

WidgetProducts.defaultProps = {
  title: 'Products',
  products: [],
};

export default WidgetProducts;
